/* eslint-disable react/destructuring-assignment */
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import IconNotif from 'assets/customIcon/PopoverNavbarContainer/IconNotif';
import { NotificationCount } from './styled';

interface NorificationIconProps {
  count: number;
  onClick?: () => void;
}

const NotificationIcon = (iconProps: NorificationIconProps) => (
  <IconWrapper {...iconProps} size="40px" style={{ marginRight: 6 }}>
    <div style={{ color: '#969696', display: 'flex', alignItems: 'center' }}>
      <IconNotif />
    </div>
    {iconProps.count > 0 && (
      <NotificationCount>
        {iconProps.count > 99 ? '99+' : iconProps.count}
      </NotificationCount>
    )}
  </IconWrapper>
);

export default NotificationIcon;
